import { useQuery } from '@apollo/client';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

import ConsultConflicts from '@components/ConsultConflicts';
import HandleQuery from '@components/HandleQuery';
import AppPage from '@components/pageTypes/AppPage';
import PageTitle from '@components/text/PageTitle';
import {
  GetOutOfOfficePeriodDocument,
  GetOutOfOfficePeriodQuery,
  GetOutOfOfficePeriodQueryVariables
} from '@typing/Generated';

type Props = {
  outOfOfficePeriodId: string;
};

const ExpertConsultConflictsPage = ({ outOfOfficePeriodId }: Props) => {
  const intl = useIntl();

  const getOutOfOfficePeriodQuery = useQuery<GetOutOfOfficePeriodQuery, GetOutOfOfficePeriodQueryVariables>(
    GetOutOfOfficePeriodDocument,
    {
      variables: { id: outOfOfficePeriodId }
    }
  );

  return (
    <AppPage>
      <Helmet>
        <title>{intl.formatMessage({ id: 'pageTitles.expert.consultConflict.list' })}</title>
      </Helmet>
      <PageTitle
        imageName="map"
        title={intl.formatMessage(
          { id: 'pages.expert.outOfOffice.consultConflictsFor' },
          { name: getOutOfOfficePeriodQuery.data?.outOfOfficePeriod.expert.fullName }
        )}
      />
      <HandleQuery query={getOutOfOfficePeriodQuery}>
        {data => (
          <div className="pageContent">
            <ConsultConflicts outOfOfficePeriod={data.outOfOfficePeriod} userIsExpert />
          </div>
        )}
      </HandleQuery>
    </AppPage>
  );
};

export default ExpertConsultConflictsPage;
